var _classCallCheck = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var ErrorCollector = require('./ErrorCollector');

var _require = require('./util'),
    getErrorFromObject = _require.getErrorFromObject,
    getErrorFromFunctionOrString = _require.getErrorFromFunctionOrString;

var _require2 = require('../testFunctions'),
    TEST_FUNCTIONS = _require2.TEST_FUNCTIONS,
    OPTIONAL = _require2.OPTIONAL;

var _require3 = require('./../util'),
    AND = _require3.AND,
    OR = _require3.OR,
    isObject = _require3.isObject;

var OPERATORS = {
  '&': AND,
  '|': OR
};

var Rule =
/*#__PURE__*/
function () {
  "use strict";

  function Rule(obj, error) {
    _classCallCheck(this, Rule);

    if (typeof obj === 'string' || obj instanceof String) {
      this.rule = {
        type: obj
      };
    } else {
      this.rule = obj;
    }

    this.error = error;
    this.errorCollector = new ErrorCollector();
    this.testEntryObject();
  }

  _createClass(Rule, [{
    key: "test",
    value: function test(val, obj, path) {
      this.errorCollector.clear();
      var types = this.getTypes();
      var operators = this.getRuleOperators();
      var ret = this.testOneRule(val, obj, types[0], path);

      for (var i = 1; i < types.length; i += 1) {
        var operator = operators[i] || operators[i - 1];
        ret = operator(ret, this.testOneRule(val, obj, types[i], path));
      }

      return ret;
    }
  }, {
    key: "getTypes",
    value: function getTypes() {
      return this.rule.type.split(/[&|]/);
    }
  }, {
    key: "getRuleOperators",
    value: function getRuleOperators() {
      var ret = [];
      var operators = this.rule.type.match(/[&|]/g) || '&';

      for (var i = 0; i < operators.length; i += 1) {
        ret.push(OPERATORS[operators[i]]);
      }

      return ret;
    }
  }, {
    key: "testOneRule",
    value: function testOneRule(val, obj, type, path) {
      if (Rule.TEST_FUNCTIONS[type].optional(val, this.rule.optional, obj) === true) {
        return true;
      }

      var keys = Object.keys(this.rule);

      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];
        var testFunction = Rule.TEST_FUNCTIONS[type][key];

        if (testFunction(val, this.rule[key], obj) === false && testFunction !== OPTIONAL) {
          this.errorCollector.collect(this.getError(path, val, key));
          return false;
        }
      }

      return true;
    }
  }, {
    key: "testEntryObject",
    value: function testEntryObject() {
      var _this = this;

      if (!this.rule.type) {
        throw Error('`type` is required');
      }

      var types = this.getTypes();
      types.forEach(function (type) {
        _this.testEntryObjectOneType(type);
      });
    }
  }, {
    key: "testEntryObjectOneType",
    value: function testEntryObjectOneType(type) {
      var keys = Object.keys(this.rule);

      for (var i = 0; i < keys.length; i += 1) {
        var key = keys[i];

        if (!Rule.TEST_FUNCTIONS[type]) {
          throw Error("The `".concat(type, "` type doesn't exist"));
        }

        if (!Rule.TEST_FUNCTIONS[type][key]) {
          throw new Error("`".concat(type, "` doesn't have \"").concat(key, "\" test!"));
        }
      }
    }
  }, {
    key: "getError",
    value: function getError(path, value, key) {
      if (isObject(this.error)) {
        return getErrorFromObject(this.error, path, value, key);
      }

      return getErrorFromFunctionOrString(this.error, path, value);
    }
  }], [{
    key: "addCustom",
    value: function addCustom(name, rule) {
      Rule.TEST_FUNCTIONS[name] = rule;
      Rule.TEST_FUNCTIONS[name].optional = OPTIONAL;
    }
  }]);

  return Rule;
}();

Rule.TEST_FUNCTIONS = TEST_FUNCTIONS;
module.exports = Rule;